/*  if you don't have any blogs yet or don't want this section to appear
 then leave this as empty string */
export const devDotToUsername = "";

export const myEmail = "nitinakadam1999@gmail.com";

export const featuredProject = [
  {
    name: "Inspired by Google Task",
    desc: "Inspired by google Task I'm created Task app using MERN Stack these app is for multiple users .here you can create your Task and update the status of task or edit it and you can delete also",
    techStack:
      "JAVASCRIPT, HTML, CSS, React and Redux,Redux thunk , Node.js, Express, MongoDB ,Chakra UI",
    githubLink: "https://github.com/nitinkadam70/GoogleTasks-App",
    demo: "https://googletaskbynitin.netlify.app/",
    image: "https://i.imgur.com/XxfQ0iY.png",
  },

  {
    name: "Inspired by PharmEasy",
    desc: "PharmEasy is a consumer healthcare “super app” that provides consumers with on-demand, home delivered access to a wide range of prescription, OTC pharmaceutical, other consumer healthcare products. and inspired by PharmEasy im created the clone of PharmEasy website",
    techStack: "JAVASCRIPT, HTML, CSS, React and Redux,Redux thunk",
    githubLink: "https://github.com/nitinkadam70/Pharmeasy",
    demo: "https://pharmeasy-clone-nitin-fw14-628.netlify.app/",
    image: "https://i.imgur.com/07WKoMK.png",
  },
  {
    name: "Bugs-Destroyer",
    desc: "This website is all about productivity, bug spotting, and problem-solving for all those out there who face problems regarding their tech journey, so don't hesitate to join our community.",
    techStack:
      "JAVASCRIPT, HTML, CSS, React and Redux,Redux thunk,Node.js, Express, MongoDB ,Chakra UI ",
    githubLink: "https://github.com/aniket2910/Bugs-Destroyer",
    demo: "https://bugs-destroyer.vercel.app/signup",
    image:
      "https://user-images.githubusercontent.com/99539536/182072480-91681a22-4e7a-4b4f-9681-0c6e2aa65d62.png",
  },
  {
    name: "Inspired by KindMeal",
    desc: "KindMeal.my is Malaysia's leading meat-free lifestyle platform, indulging you with delicious discounted vegetarian meals at cozy environments.",
    techStack: "JAVASCRIPT, HTML, CSS, React and Node.js",
    githubLink: "https://github.com/muskan2507/Kindmeal",
    demo: "https://lustrous-hotteok-719fc7.netlify.app/",
    image: "https://i.imgur.com/XncRffo.png",
  },
  {
    name: "Inspired by Groww",
    desc: "Groww is an online investment platform that allows investors to invest in mutual funds and stocks.",
    techStack: "JAVASCRIPT, HTML, CSS and Node.js",
    githubLink: "https://github.com/Parth-Bisht/Team-GROWW.git",
    demo: "https://remarkable-sopapillas-78f075.netlify.app/",
    image: "https://i.imgur.com/3fpAkAr.png",
  },
  {
    name: "Inspired by MaxFashion",
    desc: "Max Fashion is the largest fashion brand in the Middle East, North Africa, South East Asia & India.",
    techStack: "JAVASCRIPT, HTML, and CSS",
    githubLink: "https://github.com/nitinkadam70/TeamMax.git",
    demo: "https://gracious-brattain-5ae9f0.netlify.app/",
    image: "https://i.imgur.com/fYxp95R.png",
  },
  {
    name: "MealApp",
    desc: "Creating meal App with The help of React here you can See detail information about foods",
    techStack: "JAVASCRIPT, HTML, CSS, React, React Routing and Node.js",
    githubLink: "https://github.com/nitinkadam70/MealApp",
    demo: "https://frolicking-arithmetic-f91072.netlify.app/home",
    image: "	https://i.imgur.com/bf9xPXS.png",
  },
  {
    name: "Inspired by youtube",
    desc: "Creating Clone of Youtube",
    techStack: "JAVASCRIPT, HTML, CSS",
    githubLink: "https://github.com/nitinkadam70/Youtube",
    demo: "https://angry-elion-3314a2.netlify.app/",
    image: "https://i.imgur.com/cl0RbaG.png",
  },
];
